module.exports = __webpack_public_path__ + "img/img-success.59118f1f.png";